import React from 'react';
import { Typography } from 'fronton-react';
import { styled } from 'linaria/react';

const text = 'Сделаем дизайн-проект, поможем подобрать ткани, привезём и\u00A0проведем монтаж';

const ServicesRepresentationContainer = styled.div`
	margin-top: 8px;
`;

export const ServicesRepresentation = () => (
	<ServicesRepresentationContainer>
		<Typography as="p" size="subtitle" variant="m">
			{text}
		</Typography>
	</ServicesRepresentationContainer>
);
